import JobZImage from "../../../../common/jobz-img";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import { getJobDetailUrl } from "../../../../../globals/constants";
import { useEffect, useState } from "react";
import { jobService } from "../../../../../services/job-service";
import { useAuth } from "../../../../../context/AuthContext";
import SectionPagination from "../common/section-pagination";

function SectionJobsList({ onLoaded }) {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const { user } = useAuth();
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    useEffect(() => {
        setLoading(true);
        jobService.list({
            keyword: params.get("keyword") || "",
            location: params.get("location") || "",
            category: params.get("category") || "",
            subcategory: params.get("subcategory") || "",
            type: params.get("type") || ""
        })
            .then((data) => {
                setJobs(data.jobs || []);
                onLoaded?.(data.total || 0);
            })
            .catch((error) => setMessage(error.message))
            .finally(() => setLoading(false));
    }, [params, onLoaded]);

    const apply = async (jobId) => {
        if (!user) {
            navigate("/login");
            return;
        }
        if (user.role !== "candidate") {
            setMessage("Please use a candidate account to apply for jobs.");
            return;
        }
        try {
            const data = await jobService.apply(jobId);
            setMessage(data.message || "Application submitted.");
        } catch (error) {
            setMessage(error.message);
        }
    };

    const save = async (jobId) => {
        if (!user) {
            navigate("/login");
            return;
        }
        try {
            await jobService.save(jobId);
            setMessage("Job saved.");
        } catch (error) {
            setMessage(error.message);
        }
    };

    if (loading) {
        return <div className="p-a30 text-center">Loading jobs...</div>;
    }

    return (
        <>
            <div>
                {message && <div className="alert alert-info">{message}</div>}
                <div className="twm-jobs-list-wrap">
                    {jobs.length === 0 ? (
                        <div className="p-a30 site-bg-gray text-center">No jobs matched your search.</div>
                    ) : (
                        <ul>
                            {jobs.map((job, index) => (
                                <li key={job.id}>
                                    <div className="twm-jobs-list-style1 mb-5">
                                        <div className="twm-media">
                                            <JobZImage src={job.company_logo_url || job.job_image_url || `images/jobs-company/pic${(index % 5) + 1}.jpg`} alt={job.company_name || job.title} />
                                        </div>
                                        <div className="twm-mid-content">
                                            <NavLink to={getJobDetailUrl(job)} className="twm-job-title">
                                                <h4>{job.title}<span className="twm-job-post-duration"> / {formatDate(job.created_at)}</span></h4>
                                            </NavLink>
                                            <p className="twm-job-address">{job.location}</p>
                                            <div className="twm-job-websites site-text-primary">{job.company_name || "Company"}</div>
                                            <small className="d-block text-muted">Employer: {job.employer_name || "Employer"}{job.employer_phone ? ` | ${displayContact(job.employer_phone, job.mask_contact_details)}` : ""}</small>
                                            {(job.support_email || job.support_phone) && <small className="d-block text-muted">Job support: {displayEmail(job.support_email, job.mask_contact_details) || ""}{job.support_email && job.support_phone ? " | " : ""}{displayContact(job.support_phone, job.mask_contact_details) || ""}</small>}
                                        </div>
                                        <div className="twm-right-content">
                                            <div className="twm-jobs-category green"><span className="twm-bg-green">{job.job_type}</span></div>
                                            <div className="twm-jobs-amount">{salary(job)} <span>/ {job.salary_period || "Month"}</span></div>
                                            <button type="button" onClick={() => apply(job.id)} className="site-button-link site-text-primary m-r10">Apply</button>
                                            <button type="button" onClick={() => save(job.id)} className="site-button-link site-text-primary">Save</button>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                <SectionPagination />
            </div>
        </>
    )
}

function salary(job) {
    if (job.salary_min && job.salary_max) return `${formatInr(job.salary_min)} - ${formatInr(job.salary_max)}`;
    if (job.salary_min) return formatInr(job.salary_min);
    return "Salary disclosed";
}

function formatInr(value) {
    return `₹${Number(value || 0).toLocaleString("en-IN")}`;
}

function formatDate(value) {
    if (!value) return "Recently";
    return new Date(value).toLocaleDateString();
}

function displayEmail(value, privateMode) {
    if (!value || !privateMode) return value;
    const [name, domain] = value.split("@");
    return `${maskMiddle(name)}@${domain || "xxx"}`;
}

function displayContact(value, privateMode) {
    if (!value || !privateMode) return value;
    return maskMiddle(String(value));
}

function maskMiddle(value) {
    if (value.length <= 4) return "xxx";
    return `${value.slice(0, 2)}xxx${value.slice(-2)}`;
}

export default SectionJobsList;
